export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 06 The Fountain Of Life.ad98f161.mp3";